<button *ngIf="menuItem" class="sidebar-menu-item" [class.active]="url === ('/' + menuItem.route)" (click)="navigate()">
    <i [class]="menuItem.icon" class="text-2xl"></i>
    <span class="mt-2 font-semibold text-sm">{{ menuItem.title }}</span>
</button>